import { clsx } from "clsx";
import { twMerge } from "tailwind-merge";

export function cn(...inputs) {
  return twMerge(clsx(inputs));
}

export const MONTHS = [
  "Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec",
];

export const FULL_MONTHS = [
  "January", "February", "March", "April", "May", "June",
  "July", "August", "September", "October", "November", "December",
];

export function bandColor(band) {
  switch (band) {
    case "Outstanding": return "bg-emerald-100 text-emerald-700 border-emerald-200";
    case "Exceeds Expectations": return "bg-sky-100 text-sky-700 border-sky-200";
    case "Meets Expectations": return "bg-blue-50 text-blue-700 border-blue-200";
    case "Needs Improvement": return "bg-amber-100 text-amber-700 border-amber-200";
    case "Unsatisfactory": return "bg-rose-100 text-rose-700 border-rose-200";
    default: return "bg-slate-100 text-slate-600 border-slate-200";
  }
}

export function qaStatusColor(status) {
  switch (status) {
    case "Excellent": return "bg-emerald-100 text-emerald-700 border-emerald-200";
    case "Attention": return "bg-amber-100 text-amber-700 border-amber-200";
    case "Needs Improvement": return "bg-rose-100 text-rose-700 border-rose-200";
    default: return "bg-slate-100 text-slate-600 border-slate-200";
  }
}

export function performanceBand(score) {
  if (score >= 4.5) return "Outstanding";
  if (score >= 4.0) return "Exceeds Expectations";
  if (score >= 3.0) return "Meets Expectations";
  if (score >= 2.0) return "Needs Improvement";
  if (score > 0) return "Unsatisfactory";
  return "No Data";
}

// QA status from a percentage (0-100). Returns "" if input is not a finite number.
export function qaStatus(percent) {
  if (typeof percent !== "number" || !isFinite(percent)) return "";
  if (percent >= 90) return "Excellent";
  if (percent >= 80) return "Attention";
  return "Needs Improvement";
}

export function thisYear() { return new Date().getFullYear(); }
export function thisMonth() { return new Date().getMonth() + 1; }

export function classNames(...arr) { return arr.filter(Boolean).join(" "); }
